export function exchange(array, a, b) {
    const tmp = array[a];
    array[a] = array[b];
    array[b] = tmp;
}
export function bubbleUp(array, i, condition) {
    while (i && !condition(array[i - 1], array[i]))
        exchange(array, i - 1, i--);
    return i;
}
